import { render, staticRenderFns } from "./ExamHistory.vue?vue&type=template&id=00f3039a&"
import script from "./ExamHistory.vue?vue&type=script&lang=js&"
export * from "./ExamHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports